<div class="dialog-molecule-root">
  <button id="close-dialog-icon" (click)="onFailClick()" mat-icon-button class="close-button">
    <mat-icon>cancel</mat-icon>
  </button>
  <app-header *ngIf="data.title"
              id="dialog-modal-title">
    {{ data.title }}
  </app-header>
  <div mat-dialog-content>
    <app-paragraph *ngIf="data.hasDisclaimer"
                   class="extension-plan-disclaimer"
                   id="extension-plan-disclaimer"
                   [ngClass]="{'keep-white-space': contentKeepWhiteSpace}">
      <span class="disclaimer-header">
        {{ data.disclaimer }}
      </span><br>
      {{ data.contactSsupportDisclaimer }}
      <a class="faq-link" href="/faq">{{ data.faqLink }}</a>
    </app-paragraph>
    <app-paragraph *ngIf="data.content"
                   id="dialog-modal-content"
                   class="dialog-modal-content"
                   [ngClass]="{'keep-white-space': contentKeepWhiteSpace}">
      {{ data.content }}
    </app-paragraph>
  </div>
  <div *ngIf="data.secondaryContent">
    <p
      *ngFor="let item of data.secondaryContent"
      id="dialog-modal-sec-content"
      class="dialog-modal-sec-content"
      [ngClass]="{ 'keep-white-space': contentKeepWhiteSpace }"
      [ngStyle]="item.style"
      [innerHTML]="item.content"
    >
      {{ item.content }}
    </p>
  </div>
  <app-select id="modal-selector"
              *ngIf="hasOptions"
              [control]="selectControl"
              [options]="data.options"
              [label]="optionsLabel"
              [placeholder]="data.optionsPlaceholder">
    {{ data.options }}
  </app-select>
  <div mat-dialog-actions>
    <app-primary-button id="fail-dialog-btn"
                        *ngIf="data.failButtonText"
                        mat-button
                        (click)="onFailClick()"
                        [class.new-design]="data.isNewDesign">
      {{ data.failButtonText }}
    </app-primary-button>
    <app-primary-button class="success-button"
                        id="success-dialog-btn"
                        *ngIf="data.successButtonText"
                        mat-button
                        (clickAction)="onSuccessClick()"
                        [iconName]="data.successButtonIcon"
                        [abstractControl]="controlOrNothing"
                        [class.red-button]="data.isRedButton"
                        [class.new-design]="data.isNewDesign">
      {{ data.successButtonText }}
    </app-primary-button>
  </div>
</div>
